import React from 'react'
import useCurrentUser from '~/src/hooks/use-current-user'
import {
  AssetFragment,
  AssetFragmentDoc,
} from '~/src/graphql/fragments/generated/asset'
import { useUpdateAssetMutation } from '~/src/graphql/mutations/generated/update-asset'
import useFragment from '~/src/hooks/use-fragment'
import Modal from '~/src/components/modal'
import useModal from '~/src/hooks/use-modal'
import MoveDocumentForm from '~/src/pages/documents/components/move-document-form'

interface FormData {
  folder_id: string
}

export const MoveAsset = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => {
  const fragment = AssetFragmentDoc
  const {
    show,
    modalId: id,
    closeModal: onClose,
  } = useModal({
    name: 'moveAsset',
  })

  const item = useFragment<AssetFragment>({
    fragment,
    id: `Asset:${id}`,
  })

  const { currentCompanyId } = useCurrentUser()

  const defaultValues = {
    title: item?.display_name,
    existing_folder_id: item?.folder_id || '',
    folder_id: '',
    search: '',
  }

  const [updateAsset] = useUpdateAssetMutation()

  const onSubmit = async ({ folder_id }: FormData) => {
    if (!currentCompanyId || !item) {
      return
    }

    await updateAsset({
      variables: {
        id: item.id,
        company_id: currentCompanyId,
        input: {
          folder_id,
        },
      },
      refetchQueries: ['DocumentsQuery'],
    })

    onClose()
  }

  return (
    <Modal open={show} onClose={onClose}>
      {item && defaultValues && (
        <MoveDocumentForm
          onSubmit={onSubmit}
          className={className}
          defaultValues={defaultValues}
          id={id}
        />
      )}
    </Modal>
  )
}
